import {
  Mountains,
  Truck,
  ShieldCheck,
  GearSix,
  Scales,
  Broadcast,
} from "@phosphor-icons/react";
import { subdomainImage } from "./utils";

const slug = "mining";

/** Mining — mining.bizlem.com */
const miningConfig = {
  slug,
  name: "Mining",
  shortName: "Mining",
  host: "mining.bizlem.com",
  icon: Mountains,
  theme: {
    primary: "bg-amber-500",
    primaryHover: "hover:bg-amber-600",
    primaryText: "text-amber-600",
    primaryBorder: "border-amber-500",
    tint: "bg-amber-50",
    heroGradient: "from-amber-700 via-amber-500 to-amber-400",
    cream: "bg-amber-50/40",
    badge: "bg-amber-50 border-amber-200 text-amber-700",
    ring: "ring-amber-100",
  },
  hero: {
    badge: "AI-Powered Mining Intelligence",
    headline: ["Safer Sites.", "Smarter Fleets.", "Higher Yields."],
    highlightLine: 1,
    description:
      "AI-driven predictive maintenance, safety analytics, and digital mine platforms for open-pit and underground operations.",
    image: "https://images.pexels.com/photos/12201831/pexels-photo-12201831.jpeg?w=1600",
    ctaPrimary: "Request Demo",
    ctaSecondary: "Explore Solutions",
  },
  about: {
    label: "WHAT WE DO",
    heading: "Enabling mining operations with intelligent, safe ecosystems",
    body: "From pit to port, our platform connects fleet management, safety systems, ore quality, and maintenance into one AI-powered mining intelligence platform.",
  },
  modules: {
    label: "MODULES",
    heading: "Integrated Modules. One Intelligent Mine.",
    body: "Purpose-built modules for mining that work together — so safety, fleet, processing, and environmental compliance run on a single connected platform.",
    items: [
      { icon: Truck, title: "Fleet Optimization", body: "Haul cycle analytics, dispatch optimization, and fuel efficiency across open-pit and underground fleets.", iconBg: "bg-amber-100 text-amber-700" },
      { icon: ShieldCheck, title: "Safety Analytics", body: "Real-time hazard detection, incident prediction, and compliance monitoring for safer operations.", iconBg: "bg-rose-100 text-rose-700" },
      { icon: GearSix, title: "Predictive Maintenance", body: "Condition-based maintenance for crushers, conveyors, and heavy mobile equipment.", iconBg: "bg-blue-100 text-blue-700" },
      { icon: Scales, title: "Ore Quality Prediction", body: "Grade control, blending optimization, and processing plant feed quality forecasting.", iconBg: "bg-emerald-100 text-emerald-700" },
      { icon: Mountains, title: "Digital Mine Platform", body: "3D mine models, production scheduling, and real-time operational dashboards.", iconBg: "bg-violet-100 text-violet-700" },
      { icon: Broadcast, title: "Mine Command Center", body: "Unified operations view integrating safety, production, and environmental data.", iconBg: "bg-orange-100 text-orange-700" },
    ],
  },
  solutions: {
    label: "OPERATIONS",
    heading: "Built for every mining environment",
    items: [
      {
        title: "Open-Pit Mining",
        points: ["Haul road optimization", "Blast planning intelligence", "Dewatering management", "Rehabilitation tracking"],
        image: "https://images.pexels.com/photos/12201831/pexels-photo-12201831.jpeg?w=800",
      },
      {
        title: "Underground Mining",
        points: ["Ventilation monitoring", "Ground control analytics", "Underground fleet tracking", "Production scheduling"],
        image: subdomainImage(slug, "underground-mining.png"),
      },
      {
        title: "Processing Plants",
        points: ["Crushing & grinding optimization", "Recovery rate improvement", "Tailings management", "Energy consumption analytics"],
        image: "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
      },
      {
        title: "Environmental & ESG",
        points: ["Emissions monitoring", "Water quality tracking", "Rehabilitation compliance", "Community impact reporting"],
        image: subdomainImage(slug, "environmental-esg.png"),
      },
    ],
  },
  whyChoose: {
    label: "WHY CHOOSE US",
    heading: "Built for Scale. Designed for Simplicity.",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    items: [
      "One unified platform for all mining operations",
      "Scalable from single sites to multi-mine enterprises",
      "Proven safety and production improvements",
      "Environmental compliance and ESG reporting built in",
    ],
  },
  footerTagline:
    "AI-Powered Mining Intelligence — connecting safety, fleet, and production into measurable operational gains.",
  contactIndustry: "Mining",
};

export default miningConfig;
